module.exports = __webpack_public_path__ + "media/img/cat-alfredo-ce54bec8.png";